import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopularTag } from '../../../../models/global-search.model';

@Component({
  selector: 'app-popular-tags',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './popular-tags.component.html',
  styleUrl: './popular-tags.component.scss',
})
export class PopularTagsComponent {
  @Input() tags: PopularTag[] = [];
  @Output() select = new EventEmitter<string>();

  formatCount(count: number): string {
    if (count >= 1000) return `${(count / 1000).toFixed(1)}k`;
    return `${count}`;
  }
}
